export default __webpack_public_path__ + "static/media/phone.475df13c.svg";